import { useParams } from "react-router-dom";
import { useMe } from "../../hooks/useMe";
import { usePlaysAtRisk } from "../../hooks/personaQueries";

export function ReviewerHome() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { data: me } = useMe();
  const { data: plays, isLoading } = usePlaysAtRisk(workspaceId);
  const list = plays ?? [];

  return (
    <div className="main-inner" data-testid="reviewer-home">
      <div className="greet-row">
        <span className="greet">Welcome, {firstName(me?.user.displayName)}.</span>
        <span className="greet-date">READ-ONLY · AUDIT VIEW</span>
      </div>
      <div className="subgreet">
        <div className="section-eyebrow">PORTFOLIO AT A GLANCE</div>
      </div>

      <div className="rv-kpis">
        <Kpi label="Plays in flight" value={String(list.length)} sub="last 30d" />
        <Kpi label="Decisions" value="—" sub="audit only" />
        <Kpi label="Replans" value="—" sub="audit only" />
        <Kpi label="Outcomes" value="—" sub="audit only" />
      </div>

      <div className="section-h">
        <span className="ttl">STRATEGIC MOVES · TIMELINE</span>
        <span className="meta">each entry has a Trace expander</span>
      </div>
      {isLoading ? (
        <Skeleton />
      ) : list.length === 0 ? (
        <EmptyState message="No moves to display." />
      ) : (
        <div className="rv-moves">
          {list.map((p) => (
            <div key={p.id} className="rv-move">
              <div className="rv-move-i">◆</div>
              <div className="rv-move-b">
                <div className="rv-move-h">
                  <span className="pill gray">play</span>
                  <span className="rv-move-t">{p.title}</span>
                </div>
                <div className="rv-move-m">{p.state}</div>
              </div>
              <a className="rv-move-tr">Trace →</a>
            </div>
          ))}
        </div>
      )}

      <div className="rv-note">
        Read-only audit view · No actions are available from this surface.
      </div>
    </div>
  );
}

function firstName(displayName?: string): string {
  if (!displayName) return "there";
  return displayName.split(/\s+/)[0] ?? displayName;
}

function Kpi({ label, value, sub }: { label: string; value: string; sub: string }) {
  return (
    <div className="rv-kpi">
      <div className="rv-kpi-l">{label}</div>
      <div className="rv-kpi-v">{value}</div>
      <div className="rv-kpi-s">{sub}</div>
    </div>
  );
}

function Skeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          style={{ height: 48, background: "var(--bg-soft)", opacity: 0.6, borderRadius: 6 }}
        />
      ))}
    </div>
  );
}

function EmptyState({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 24,
        textAlign: "center",
        color: "var(--text-3)",
        border: "1px dashed var(--border)",
        borderRadius: 8,
        fontSize: 13,
      }}
    >
      {message}
    </div>
  );
}
